import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { RowOrCol3a33s3yce2tuv as RowOrCol } from './LinearLayouts.commonHtml.mjs';
import { ensureOutermostElement1f4fzdv7yw0ql as ensureOutermostElement } from '../NativeElement.mjs';
import {
  renderListExpensive1uww6gegn7pye as renderListExpensive,
  renderListKeyed2aa8xagnzn29y as renderListKeyed,
  renderList2ygesqkknbufi as renderList,
  renderListExpensive2jy2o58jy5yrj as renderListExpensive_0,
} from '../foreach.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function rowOfExpensive(_this__u8e3s4, items, beforeModifier, render) {
  var tmp;
  if (beforeModifier === VOID) {
    tmp = rowOfExpensive$lambda;
  } else {
    tmp = beforeModifier;
  }
  beforeModifier = tmp;
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element = new (RowOrCol())(_this__u8e3s4.get_context_h02k06_k$());
  ensureOutermostElement(element);
  _this__u8e3s4.willAddChild_hz2iwc_k$(element);
  element.set_vertical_nuap32_k$(false);
  renderListExpensive(element, items, beforeModifier, render);
  element.onStartup_vrxh3i_k$();
  _this__u8e3s4.addChild_2qpft2_k$(element);
  return element;
}
function colOfExpensive(_this__u8e3s4, items, beforeModifier, render) {
  var tmp;
  if (beforeModifier === VOID) {
    tmp = colOfExpensive$lambda;
  } else {
    tmp = beforeModifier;
  }
  beforeModifier = tmp;
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element = new (RowOrCol())(_this__u8e3s4.get_context_h02k06_k$());
  ensureOutermostElement(element);
  _this__u8e3s4.willAddChild_hz2iwc_k$(element);
  element.set_vertical_nuap32_k$(true);
  renderListExpensive(element, items, beforeModifier, render);
  element.onStartup_vrxh3i_k$();
  _this__u8e3s4.addChild_2qpft2_k$(element);
  return element;
}
function colOf(_this__u8e3s4, items, id, animate, preHidingModifiers, render) {
  animate = animate === VOID ? true : animate;
  var tmp;
  if (preHidingModifiers === VOID) {
    tmp = colOf$lambda;
  } else {
    tmp = preHidingModifiers;
  }
  preHidingModifiers = tmp;
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element = new (RowOrCol())(_this__u8e3s4.get_context_h02k06_k$());
  ensureOutermostElement(element);
  _this__u8e3s4.willAddChild_hz2iwc_k$(element);
  element.set_vertical_nuap32_k$(true);
  renderListKeyed(element, items, id, animate, preHidingModifiers, render);
  element.onStartup_vrxh3i_k$();
  _this__u8e3s4.addChild_2qpft2_k$(element);
  return element;
}
function colOf_0(_this__u8e3s4, items, placeholdersWhileLoading, poolCap, beforeModifier, render) {
  placeholdersWhileLoading = placeholdersWhileLoading === VOID ? 5 : placeholdersWhileLoading;
  poolCap = poolCap === VOID ? 32 : poolCap;
  var tmp;
  if (beforeModifier === VOID) {
    tmp = colOf$lambda_0;
  } else {
    tmp = beforeModifier;
  }
  beforeModifier = tmp;
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element = new (RowOrCol())(_this__u8e3s4.get_context_h02k06_k$());
  ensureOutermostElement(element);
  _this__u8e3s4.willAddChild_hz2iwc_k$(element);
  element.set_vertical_nuap32_k$(true);
  renderList(element, items, placeholdersWhileLoading, poolCap, beforeModifier, render);
  element.onStartup_vrxh3i_k$();
  _this__u8e3s4.addChild_2qpft2_k$(element);
  return element;
}
function rowOf(_this__u8e3s4, items, id, animate, preHidingModifiers, render) {
  animate = animate === VOID ? true : animate;
  var tmp;
  if (preHidingModifiers === VOID) {
    tmp = rowOf$lambda;
  } else {
    tmp = preHidingModifiers;
  }
  preHidingModifiers = tmp;
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element = new (RowOrCol())(_this__u8e3s4.get_context_h02k06_k$());
  ensureOutermostElement(element);
  _this__u8e3s4.willAddChild_hz2iwc_k$(element);
  element.set_vertical_nuap32_k$(false);
  renderListKeyed(element, items, id, animate, preHidingModifiers, render);
  element.onStartup_vrxh3i_k$();
  _this__u8e3s4.addChild_2qpft2_k$(element);
  return element;
}
function colOfExpensive_0(_this__u8e3s4, items, animate, beforeModifier, render) {
  var tmp;
  if (beforeModifier === VOID) {
    tmp = colOfExpensive$lambda_0;
  } else {
    tmp = beforeModifier;
  }
  beforeModifier = tmp;
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element = new (RowOrCol())(_this__u8e3s4.get_context_h02k06_k$());
  ensureOutermostElement(element);
  _this__u8e3s4.willAddChild_hz2iwc_k$(element);
  element.set_vertical_nuap32_k$(true);
  renderListExpensive_0(element, items, animate, beforeModifier, render);
  element.onStartup_vrxh3i_k$();
  _this__u8e3s4.addChild_2qpft2_k$(element);
  return element;
}
function rowOfExpensive$lambda(_this__u8e3s4, it) {
  return _this__u8e3s4;
}
function colOfExpensive$lambda(_this__u8e3s4, it) {
  return _this__u8e3s4;
}
function colOf$lambda(_this__u8e3s4) {
  return _this__u8e3s4;
}
function colOf$lambda_0(_this__u8e3s4) {
  return _this__u8e3s4;
}
function rowOf$lambda(_this__u8e3s4) {
  return _this__u8e3s4;
}
function colOfExpensive$lambda_0(_this__u8e3s4, it) {
  return _this__u8e3s4;
}
//region block: exports
export {
  colOfExpensive as colOfExpensive3l2ndrv33zay6,
  colOfExpensive_0 as colOfExpensive3ig8osrmgzdfv,
  colOf as colOf78ko504rukk8,
  colOf_0 as colOfv2oygjkn5hb2,
  rowOfExpensive as rowOfExpensive14cfdwaubaywj,
  rowOf as rowOf3phwx1yo72ntt,
};
//endregion

//# sourceMappingURL=lists.mjs.map
